import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { logoutUser } from '../../../reducer/user.reducer';

const TopNav = ({ isMenuActive, toggleMenu }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const loggedInUser = useSelector((root) => root.user?.loggedInUser) || {};

    const logout = async () => {
        try {
            toast.loading('Logging out...');
            await fetch(`${import.meta.env.VITE_API_URL}/auth/logout`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('_at')}`,
                },
            });
        } catch (error) {
            console.error('Logout API call failed:', error);
        } finally {
            localStorage.removeItem('_at');
            localStorage.removeItem('_rt');
            dispatch(logoutUser());
            toast.dismiss();
            toast.success('Logged out successfully');

            setTimeout(() => {
                window.location.href = '/login';
            }, 800);
        }
    };

    return (
        <header className="w-full bg-white border-b border-stone-200/80 px-4 sm:px-6 py-3.5 flex items-center justify-between gap-4 sticky top-0 z-30 shadow-2xs min-w-0">
            <ToastContainer />

            {/* Left: Hamburger Button (Mobile) & Welcome Message */}
            <div className="flex items-center gap-3 min-w-0">
                {/* Mobile Hamburger Toggle */}
                <button
                    onClick={toggleMenu}
                    className="p-2 rounded-xl text-stone-600 hover:bg-stone-100 md:hidden focus:outline-none transition-colors"
                    aria-label="Toggle Navigation Menu"
                >
                    <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        {isMenuActive ? (
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                        ) : (
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                        )}
                    </svg>
                </button>

                <div className="min-w-0">
                    <h1 className="text-sm sm:text-base font-bold text-stone-900 tracking-tight truncate">
                        Welcome Back, {loggedInUser.name || 'Admin'}
                    </h1>
                    <p className="text-[11px] text-stone-400 font-medium hidden sm:block">
                        Store Management Portal
                    </p>
                </div>
            </div>

            {/* Right: User Profile & Logout Action */}
            <div className="flex items-center gap-3 flex-shrink-0">
                <button
                    onClick={logout}
                    className="px-3.5 py-1.5 bg-stone-900 hover:bg-stone-800 text-white rounded-xl text-xs font-semibold transition-all shadow-xs flex items-center gap-2"
                >
                    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                    </svg>
                    <span>Log Out</span>
                </button>
            </div>
        </header>
    );
};

export default TopNav;